module.exports = __webpack_public_path__ + "static/media/twitter-shadow.eefd194c.png";